import * as common from './common'
import * as cropper from './cropper'
import * as dealsEntities from './entities/deals'
import * as draftDeals from './draft-deals'
import * as draftEventGroup from './draft/eventgroup'
import * as eventGroup from './event-group'
import * as eventGroupsEntities from './entities/event-groups'
import * as eventTypesEntities from './entities/event-types'
import * as grid from './grid'
import * as home from './home'
import * as navigation from './navigation'
import * as partnerSettingsEntities from './entities/partner-settings'
import * as performance from './performance'
import * as performanceEntities from './entities/performance'
import * as promoCode from './promo-code'
import * as promoCodeEntities from './entities/promo-code'
import * as sellableItemEntities from './entities/sellable-item'
import * as settings from './settings'
import * as settingsEntities from './entities/settings'
import * as setupform from './setupform'
import * as setupformVoucher from './setupform-voucher'
import * as setupformEntities from './entities/setupform'
import * as signup from './signup'
import * as ticketsEntities from './entities/tickets'
import * as venuesEntities from './entities/venues'

export default {
  ...common,
  ...cropper,
  ...dealsEntities,
  ...draftDeals,
  ...draftEventGroup,
  ...eventGroup,
  ...eventGroupsEntities,
  ...eventTypesEntities,
  ...grid,
  ...home,
  ...navigation,
  ...partnerSettingsEntities,
  ...performance,
  ...performanceEntities,
  ...promoCode,
  ...promoCodeEntities,
  ...sellableItemEntities,
  ...settings,
  ...settingsEntities,
  ...setupform,
  ...setupformVoucher,
  ...setupformEntities,
  ...signup,
  ...ticketsEntities,
  ...venuesEntities,
}



/** WEBPACK FOOTER **
 ** ./src/actions/index.js
 **/